module.exports = __webpack_public_path__ + "static/media/cases_3d_07b.58bed0e0.jpg";